import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate, useParams } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useModal, useResource, useToast, usePage } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { BASE, URLS, APIS, SF_HLDY_MGMT_INFO } from "@/tra/tancis/ptli/crtr/hldy/services/PtliHldyMgmtService";

/*
 * Holiday Management Modification
 * !== 휴일관리 수정 ==!
 */
export const PTLI0408003S = () => {
    useResource({
        defaultSchema: [{ area: "cstmCd" }, { area: "comnCd", comnCd: "COM0057" }],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { hldyId } = useParams();
    const modal = useModal();
    const toast = useToast();

    const form = {
        hldyMgmtInfo: useForm({
            defaultSchema: SF_HLDY_MGMT_INFO,
        }),
    };

    const fetch = {
        getHldyMgmtInfo: useFetch({
            api: () => APIS.getHldyMgmtInfo(hldyId),
            onSuccess: (data: any) => {
                // 데이터가 없을 경우
                if (!data.hldyMgmtInfo.content) {
                    modal.openModal({ content: "msg.com.00034" }); // No data found. !== 해당 데이터가 없습니다. ==!

                    navigate(`${URLS.ptli0408001q}?menuId=${menuId}`);
                    return;
                }
                form.hldyMgmtInfo.setValues(data.hldyMgmtInfo.content);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
        updateHldyMgmtInfo: useFetch({
            api: (info: any) => APIS.updateHldyMgmtInfo(info),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00059" }); // Successfully updated. !== 정상적으로 수정되었습니다.==!
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00022" }), // Failed to update. !== 수정이 실패하였습니다.==!
        }),
        deleteHldyMgmtInfo: useFetch({
            api: (info: any) => APIS.deleteHldyMgmtInfo(info),
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00060" }); // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                navigate(`${URLS.ptli0408001q}?menuId=${menuId}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00023" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.ptli0408001q}?menuId=${menuId}`),
        onUpdateBtnClick: form.hldyMgmtInfo.handleSubmit(
            () => {
                modal.openModal({
                    content: "msg.com.00050", // Confirm update? !== 수정하시겠습니까? ==!
                    onConfirm: () => fetch.updateHldyMgmtInfo.fetch(form.hldyMgmtInfo.getValues()),
                });
            },
            () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => fetch.deleteHldyMgmtInfo.fetch(form.hldyMgmtInfo.getValue("hldyId")),
            });
        },
    };

    useEffect(() => {
        fetch.getHldyMgmtInfo.fetch();
        form.hldyMgmtInfo.setSchema("hldyId", { edit: false });
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hldyMgmtInfo.schema.hldyNm} />
                            <Group.Control {...form.hldyMgmtInfo.schema.ctraDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hldyMgmtInfo.schema.hldyTpCd} />
                            <Group.Control {...form.hldyMgmtInfo.schema.cstmOfceCd} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onUpdateBtnClick} />
                    <Layout.Button role={"delete"} onClick={handler.onDeleteBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
